<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useResizeObserver } from '@vueuse/core'
import { faArrowLeft, faArrowRight } from '@fortawesome/duotone-regular-svg-icons'
import Button from '~/components/ui/Button.vue'

const leftButtonHidden = ref(true)
const rightButtonHidden = ref(true)
const list = ref<HTMLElement | null>(null)

function onScroll() {
  const ul = list.value
  if (!ul)
    return

  leftButtonHidden.value = ul.scrollLeft <= 2
  rightButtonHidden.value = Math.floor(ul.scrollWidth - ul.scrollLeft) <= Math.ceil(ul.offsetWidth)
}

function onClick(direction: string) {
  if (!list.value)
    return
  const scrollAmount = list.value.offsetWidth
  list.value.scrollBy({
    left: direction === 'left' ? -scrollAmount : scrollAmount,
    behavior: 'smooth'
  })
}

useResizeObserver(list, () => onScroll())

onMounted(() => {
  onScroll()
})
</script>

<template>
  <div
    role="region"
    class="relative -mx-4"
  >
    <div class="hidden sm:block">
      <Button
        class="absolute top-1/2 -left-4 z-10 -translate-y-1/2 transition-opacity duration-200"
        :class="leftButtonHidden ? 'pointer-events-none invisible opacity-0' : 'visible opacity-100'"
        shape="square"
        color="white"
        aria-label="Rull mot venstre"
        @click="onClick('left')"
      >
        <font-awesome-icon :icon="faArrowLeft" />
      </Button>

      <Button
        class="absolute top-1/2 -right-4 z-10 -translate-y-1/2 transition-opacity duration-200"
        :class="rightButtonHidden ? 'pointer-events-none invisible opacity-0' : 'visible opacity-100'"
        shape="square"
        color="white"
        aria-label="Rull mot høyre"
        @click="onClick('right')"
      >
        <font-awesome-icon :icon="faArrowRight" />
      </Button>
    </div>

    <ul
      ref="list"
      class="no-scrollbar flex snap-x snap-mandatory scroll-p-8 flex-nowrap items-stretch justify-start gap-[1.3rem] overflow-x-auto scroll-smooth px-4 py-[1.2rem]"
      @scroll="onScroll"
    >
      <slot />
    </ul>
  </div>
</template>

<style scoped>
.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
